import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Field } from '../Field';
import { FormItem } from './FormItem';
import { VFFieldProps } from '../types';
import { IMask, IMaskInput } from 'react-imask';
import classNames from 'classnames';
import { useRef } from 'react';

export const TimeMaskOptions = {
  overwrite: true,
  autofix: true,
  mask: 'HH:MM',
  blocks: {
    HH: {
      mask: IMask.MaskedRange,
      placeholderChar: 'HH',
      from: 0,
      to: 23,
      maxLength: 2,
    },
    MM: {
      mask: IMask.MaskedRange,
      placeholderChar: 'MM',
      from: 0,
      to: 59,
      maxLength: 2,
    },
  },
};

export type TimeProps = VFFieldProps<React.ComponentProps<typeof IMaskInput>>;
export const Time = React.forwardRef<HTMLInputElement, TimeProps>(
  ({
    name,
    validate,
    className,
    inputClassName,
    label,
    disabled,
    required,
    ...other
  }) =>
    /*,
    ref*/
    {
      const inputRef = useRef<any>();
      const inputValue = useRef<any>('');
      const tempValue = useRef<any>('');

      return (
        <FormItem
          name={name}
          className={className}
          label={label}
          required={required}
          disabled={disabled}
        >
          <Field name={name} validate={validate}>
            {({
              input: { value, onChange, onBlur, name, ...nother },
            }: FieldRenderProps<number>) => {
              inputValue.current = value;

              return (
                <IMaskInput
                  {...TimeMaskOptions}
                  {...other}
                  {...nother}
                  value={value}
                  unmask={false} // true|false|'typed'
                  inputRef={(x: any) => {
                    inputRef.current = x;
                  }}
                  disabled={disabled}
                  name={name}
                  className={classNames(inputClassName, 'bp3-fill bp3-input')}
                  // DO NOT USE onChange TO HANDLE CHANGES!
                  // USE onAccept INSTEAD
                  onBlur={(e: any) => {
                    const val = e.target.value || '';
                    if (
                      val.length !== 5 ||
                      inputValue.current !== tempValue.current
                    ) {
                      if (val.length === 0) {
                        // inputRef.current.value = '';
                        onChange('');
                        onBlur({
                          target: { name, value: '' },
                        } as any as React.FocusEvent<HTMLElement>);
                      } else {
                        let time = val.replaceAll(/:/g, '');
                        time += '0000'.substring(time.length);
                        onChange(time);
                        onBlur({
                          target: { name, value: time },
                        } as any as React.FocusEvent<HTMLElement>);
                      }
                    } else {
                      onBlur({
                        target: { name, value: val },
                      } as any as React.FocusEvent<HTMLElement>);
                    }
                  }}
                  onAccept={
                    // depending on prop above first argument is
                    // `value` if `unmask=false`,
                    // `unmaskedValue` if `unmask=true`,
                    // `typedValue` if `unmask='typed'`
                    (value: any, mask: any) => {
                      if (value && mask?.value?.length === 5) {
                        onChange(mask.value);
                      }
                      tempValue.current = value;
                    }
                  }
                  // ...and more mask props in a guide
                  // input props also available
                  // placeholder="Enter number here"
                />
              );
            }}
          </Field>
        </FormItem>
      );
    }
);
